<div>
    <label class="toggle">
        <input type="checkbox" [checked]="isChecked" (click)="toggle($event)" />

        <span class="slider round"></span>
    </label>
</div>
